<v-form @submit.prevent="submit" ref="form">
    <div class="d-flex">
        <v-text-field
            variant="outlined"
            density="compact"
            validate-on="blur"
            class="shrink security-code-panel mr-4"
            :label="secuityCodeData.label"
            placeholder="Enter security code"
            :rules="secuityCodeData.rules"
            v-model="twoFactorPassword"></v-text-field>

        <v-btn
            class="submit-button"
            type="submit"
            variant="flat"
            tile
            color="primary"
            :loading="loading">
            Confirm
        </v-btn>
    </div>
</v-form>